import script from "./InvestigationCompleted.vue?vue&type=script&setup=true&lang=js"
export * from "./InvestigationCompleted.vue?vue&type=script&setup=true&lang=js"

import "./InvestigationCompleted.vue?vue&type=style&index=0&id=6e935bea&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e935bea"]])

export default __exports__